import cn from "classnames"

import { renameTitle, ChildrenCategories } from "modules/PsyProfile/common/utils"
import { CompetencesList } from "modules/PsyProfile/components/Competences/components"
import style from "modules/PsyProfile/components/Competences/styles.module.scss"
import { EmojiTag } from "components"
import { DOMAIN_PREFIX } from "utils/env-management"
import { Psychologist } from "utils/interfaces"
import { TherapyRequestLookups } from "modules/PsyCommon/components/TherapyRequestLookups"
import { sortCompetence } from "modules/PsyProfile/components/Competences/components/CompetencesList/getColumnCompetences"
import { ReportedProblemsStorage } from "utils/ReportedProblemsStorage"

interface Props {
    psy: Psychologist
}

interface WorkingWithProps {
    title: string
    img: string
    check(psy: Psychologist): boolean
}

const workingWith: WorkingWithProps[] = [
    {
        title: "Взрослые",
        img: `${DOMAIN_PREFIX}/images/man-tipping-hand-emoji.png`,
        check: (psy) => Boolean(psy.working_with.adults.adults),
    },
    {
        title: "Семьи",
        img: `${DOMAIN_PREFIX}/images/family-emoji.png`,
        check: (psy) => Boolean(psy.working_with.family.family),
    },
    {
        title: "Пары",
        img: `${DOMAIN_PREFIX}/images/couple-emoji.png`,
        check: (psy) => Boolean(psy.working_with.adults.couples),
    },
    {
        title: "Люди в возрасте",
        img: `${DOMAIN_PREFIX}/images/older-emoji.png`,
        check: (psy) => Boolean(psy.working_with.adults.elderly),
    },
]

const workingWithChildren: WorkingWithProps[] = [
    {
        title: ChildrenCategories["children_3_10"],
        img: `${DOMAIN_PREFIX}/images/child.png`,
        check: (psy) => Boolean(psy.working_with.children.children_3_10),
    },
    {
        title: ChildrenCategories["children_11_15"],
        img: `${DOMAIN_PREFIX}/images/books.png`,
        check: (psy) => Boolean(psy.working_with.children.children_11_15),
    },
    {
        title: ChildrenCategories["children_16_18"],
        img: `${DOMAIN_PREFIX}/images/skateboard.png`,
        check: (psy) => Boolean(psy.working_with.children.children_16_18),
    },
]

export function Competences({ psy }: Props) {
    const reportedProblemsNumbers = ReportedProblemsStorage.reportedProblemsId
    const competences =
        reportedProblemsNumbers.length > 0
            ? sortCompetence(reportedProblemsNumbers, psy.competences)
            : psy.competences

    const withPlayer = Boolean(psy.audio) || TherapyRequestLookups.isCanBeShown(psy.hash_id)

    const renderEmojiTags = (items: WorkingWithProps[], rename = false) =>
        items.map(({ title, img, check }) =>
            check(psy) ? (
                <EmojiTag imgLink={img} key={title} className={style.emojiItem}>
                    {rename ? renameTitle(title) : title}
                </EmojiTag>
            ) : null
        )

    return (
        <section className={style.container}>
            <div
                className={cn({
                    [style.audioPlayerSpace]: withPlayer,
                })}
            >
                <div className={style.header} data-testid="psy-profile-competences-help-title">
                    С чем поможет
                </div>
                <CompetencesList competences={competences} />
                <div className={style.header} data-testid="psy-profile-competences-work-title">
                    С кем работает
                </div>
                <div className={style.emoji}>
                    {renderEmojiTags(workingWith)}
                    {renderEmojiTags(workingWithChildren, true)}
                </div>
            </div>
        </section>
    )
}
